import { Country } from "../lib/country";

const countryData: Country[] = require("../data/country_data.json").features;

export const answerName = "Portugal";
export const answerCountry = countryData[131];
